import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/common/app';
export default class TagListState {
  constructor() {
    _defineProperty(this, "loadedIncludes", void 0);
  }
  async load(includes) {
    if (includes === void 0) {
      includes = [];
    }
    if (!this.loadedIncludes) {
      return this.query(includes);
    }
    const unloadedIncludes = includes.filter(include => !this.loadedIncludes.has(include));
    if (unloadedIncludes.length === 0) {
      return Promise.resolve(app.store.all('tags'));
    }
    return this.query(unloadedIncludes);
  }
  async query(includes) {
    var _this$loadedIncludes;
    if (includes === void 0) {
      includes = [];
    }
    (_this$loadedIncludes = this.loadedIncludes) != null ? _this$loadedIncludes : this.loadedIncludes = new Set();
    return app.store.find('tags', {
      include: includes.join(',')
    }).then(val => {
      const tags = Array.isArray(val) ? val : [val];
      includes.forEach(include => this.loadedIncludes.add(include));
      return tags;
    });
  }
}
flarum.reg.add('flarum-tags', 'common/states/TagListState', TagListState);